import { render, staticRenderFns } from "./HealthPushDialog.vue?vue&type=template&id=9a477398&scoped=true&"
import script from "./HealthPushDialog.vue?vue&type=script&lang=js&"
export * from "./HealthPushDialog.vue?vue&type=script&lang=js&"
import style0 from "./HealthPushDialog.vue?vue&type=style&index=0&id=9a477398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a477398",
  null
  
)

export default component.exports